import React, {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const PepperjamScript = (location) => {
    const {
        app: {commerceAPI}
    } = getConfig()

    const {pepperjam} = commerceAPI
    const {config} = pepperjam || {}

    var pepperjamEnabled = false
    var pepperjamNoscriptURL = null
    var pepperjamScriptURL = null

    try {
        const jsonConfig = JSON.parse(config)
        pepperjamEnabled = jsonConfig.enabled
        pepperjamNoscriptURL = jsonConfig.noScriptURL
        pepperjamScriptURL = jsonConfig.scriptUrl
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (pepperjamEnabled && pepperjamNoscriptURL && pepperjamScriptURL) {
            if (document.querySelectorAll('[src="' + pepperjamScriptURL + '"]').length > 0) {
                return
            }

            // pepperjam noscript
            const noscript = document.createElement('noscript')
            const iframe = document.createElement('iframe')
            iframe.src = pepperjamNoscriptURL
            iframe.width = '1'
            iframe.height = '1'
            iframe.frameborder = '0'
            noscript.textContent =
                '<iframe src="' +
                pepperjamNoscriptURL +
                '" width="1" height="1" frameborder="0"></iframe>'

            document.querySelector('footer').appendChild(noscript)

            // pepperjam script
            const script = document.createElement('script')
            script.src = pepperjamScriptURL
            script.type = 'text/javascript'
            script.async = true
            script.defer = true
            document.head.appendChild(script)

            return () => {
                // safe cleanup
                if (script && script.parentNode) {
                    script.parentNode.removeChild(script)
                }

                if (noscript && noscript.parentNode) {
                    noscript.parentNode.removeChild(noscript)
                }
            }
        }
    }, [pepperjamEnabled, pepperjamNoscriptURL, pepperjamScriptURL, location])

    return <></>
}

export default PepperjamScript
